// What a stored jurisdiction (value column) name READS as on the parcel card and in reports.
//
// ⛔ DISPLAY ONLY. The stored name is the key: values, savings-baseline markers, deductions, saved tax rates and
// scanned values all pair columns by it, and Florida's scanner writes "Public Schools" (noticeRateLines). Never
// match, group-by-key or write with the label — only show it. (Philip 2026-10-21: every school column is stored
// as "Public Schools" and reads "School".)
//
// No imports on purpose: taxBill, baselineSavings, appealRows and the reports all use it, so it can't join a cycle.
export const SCHOOL_JURISDICTION = 'Public Schools';

const LABELS = { [SCHOOL_JURISDICTION]: 'School' };

export const jurisdictionLabel = (name) => (name == null ? name : LABELS[name] || name);
